<template>
<div>
    <Header :allowSK="allowSK" />
    <Stepper v-if="!submitting" :stepper="stepper" @step="goToStep" @submit="onSubmit" :showMessage="stepper.key == 'key1'" :messageError="topError" :messageText="topMessage" />
    <NavButtons v-if="!submitting" :stepper="stepper" @step="goToStep" @submit="onSubmit" />

    <div v-if="!loading && !submitting" class="form-container" :class="{'top-message-margin': stepper.key == 'key1'}">

        <vm-form v-show="stepper.key == 'key1'">
            <Customer v-model="customer" @validated="onCustomerValidated" />
        </vm-form>

        <vm-form v-show="stepper.key == 'key2'">

            <Economy :customer="customer" />

            <vm-card v-if="flow.status.wasRejected" list :header="'Melding fra ' + flow.approver.fname">
                <div class="approval-info-c">
                    <div class="approval-info">
                        <div class="approval-info-icon">
                            <svg height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" style="transform: scale(0.55);">
                                <path d="M16 0C7.2 0 0 7.2 0 16C0 24.8 7.2 32 16 32C24.8 32 32 24.8 32 16C32 7.2 24.8 0 16 0ZM17.5 24.7C17.5 24.8 17.4 24.9 17.3 24.9H14.8C14.7 24.9 14.6 24.8 14.6 24.7V12.6C14.6 12.5 14.7 12.4 14.8 12.4H17.3C17.4 12.4 17.5 12.5 17.5 12.6V24.7ZM17.5 9.8C17.5 9.9 17.4 10 17.3 10H14.8C14.7 10 14.6 9.9 14.6 9.8V7.3C14.6 7.2 14.7 7.1 14.8 7.1H17.3C17.4 7.1 17.5 7.2 17.5 7.3V9.8Z"/>
                            </svg>
                        </div>
                        <div class="approval-info-text">
                            <label>{{ flow.status.message }}</label>
                        </div>
                    </div>
                </div>
            </vm-card>

            <ShippingTable v-model="shipping" @validated="onShippingValidated" :skEnabled="$parent.skEnabled" :thresholdValues="thresholdValues" />
	        
	        <vm-card :header="__('additional_info')">
		        
		        <template v-slot:actions>
		        <vm-tooltip-action :html="__('additional_info_tt')"/>
		        </template>
		        
		        <vm-group c12 class="af-textarea">
			        <vm-label :text="flow.additionalInfo.length + '/' + __('additional_info_max')"/>
			        <textarea :maxlength="__('additional_info_max')"
			                  :placeholder="__('additional_info_ph')"
			                  v-model="flow.additionalInfo"
			                  @change="onAdditionalInfoChanged"></textarea>
		        </vm-group>
	        </vm-card>

        </vm-form>

        <vm-form v-show="stepper.key == 'key3'">
            <vm-card list :header="__('approval')">
                <div class="approval-info-c">
                    <div class="approval-info" :class="{'approval-none':!needsApproval}">
                        <div class="approval-info-icon">
                            <svg height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" style="transform: scale(0.55);">
                                <path d="M16 0C7.2 0 0 7.2 0 16C0 24.8 7.2 32 16 32C24.8 32 32 24.8 32 16C32 7.2 24.8 0 16 0ZM17.5 24.7C17.5 24.8 17.4 24.9 17.3 24.9H14.8C14.7 24.9 14.6 24.8 14.6 24.7V12.6C14.6 12.5 14.7 12.4 14.8 12.4H17.3C17.4 12.4 17.5 12.5 17.5 12.6V24.7ZM17.5 9.8C17.5 9.9 17.4 10 17.3 10H14.8C14.7 10 14.6 9.9 14.6 9.8V7.3C14.6 7.2 14.7 7.1 14.8 7.1H17.3C17.4 7.1 17.5 7.2 17.5 7.3V9.8Z"/>
                            </svg>
                        </div>
                        <div class="approval-info-text">
                            <label v-if="!needsApproval">Denne avtalen trenger ikke godkjenning</label>
                            <label v-if="needsApproval">Denne avtalen trenger godkjenning</label>
                        </div>
                    </div>
                </div>
                <vm-row v-if="needsApproval">
                    <vm-group c12>
                        <vm-label :text="__('approver')" />
                        <vm-dropdown v-model="selectedApprover" 
                            :options="$parent.approvers" 
                            :placeholder="'Velg hvem som skal godkjenne'"
                            @input="onApproverSelected"
                        />
                    </vm-group>
                </vm-row>
            </vm-card>
        </vm-form>

    </div>

    <div v-if="submitted" class="main-message card-shadow">
        <div style="width: 400px; margin-left: -200px; text-align: center; margin-bottom: 30px; margin-top: 20px;">
            <svg height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" style="transform: scale(2.0);">
                <path d="M16 32C24.8 32 32 24.8 32 16C32 7.2 24.8 0 16 0C7.2 0 0 7.2 0 16C0 24.8 7.2 32 16 32ZM13 19.4L23 10C23.5 9.5 24.3 9.5 24.8 10C25.3 10.5 25.3 11.2 24.8 11.7L13.9 22C13.7 22.2 13.3 22.3 13 22.3C12.7 22.3 12.3 22.2 12.1 22L7.1 17.4C6.6 16.9 6.6 16.2 7.1 15.7C7.6 15.2 8.4 15.2 8.9 15.7L13 19.4Z"/>
            </svg>
        </div>
        <div style="width: 400px; margin-left: -200px; text-align: center; font-size: 18px;">
            <p>Fraktavtalen er sendt til godkjenning.</p>
            <p>Du kan nå lukke fanen.</p>
        </div>
    </div>

</div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
import axios from 'axios';
import maxbo from '../maxbo';
import superoffice from '../superoffice';
import shippingapi from '../shippingapi';
import verified from '../verified';
import log from '../log';

import Header from '../components/nav/Header';
import Stepper from '../components/nav/Stepper';
import NavButtons from '../components/nav/NavButtons';

import Customer from '../components/Customer';
import Economy from '../components/Economy';
import ShippingTable from '../components/ShippingTable';
import nformat from '../nformat';
import VueCookies from 'vue-cookies';
import Vue from 'vue';

export default {
name: 'Shipping',
components: {
    Header,
    Stepper,
    NavButtons,
    Customer,
    Economy,
    ShippingTable
},
data() {
    return {
        loading: true,
        submitting: false,
        submitted: false,
        stepper: {
            step: 1,
            steps: [],
            key: ''
        },
        topError: false,
        topMessage: '',
        allowSK: false,
        customer: {},
        shipping: {},
        checks: {},
        needsApproval: false,
        approver: {
            name: 'Magnus Approver Ursin',
            email: 'magnus.ursin+approver@verified.eu'
        },
        selectedApprover: undefined,
        approverValid: false,
        flow: {
            step: 0,
            status: { wasRejected: false },
	        additionalInfo: ''
        },
        checks: {
            category: false,
            economy: {
                depositsExpected: false,
                creditLimit: false
            }
        },
        thresholdValues: []
    }
},
methods: {
    // --- Stepper Logic --------------------------------
    goToStep(key) {
        for (let i in this.stepper.steps) {
            if (this.stepper.steps[i].key == key) {
                this.stepper.step = Number(i) + 1;
                this.stepper.key = key;
            }
        }
        if (key == 'key3') {
            if (this.needsApproval) {
                this.updateStep('key3', 'nText', 'Send til godkjenning');
                this.updateStep('key3', 'nDisabled', !this.approverValid);
            }else {
                this.updateStep('key3', 'nText', 'Oppdater fraktavtale');
                this.updateStep('key3', 'nDisabled', false);
            }
        }
    },
    updateStep(key, name, value) {
        for (let i in this.stepper.steps) {
            if (this.stepper.steps[i].key == key) {
                this.stepper.steps[i][name] = value;
            }
        }
    },
    initSteps(startStep) {
        this.stepper.steps = [
            {
                key: 'key1',
                label: 'Kundeinformasjon',
                pDisabled: true, nDisabled: true,
                pText: 'Tilbake', nText: 'Neste'
            },
            {
                key: 'key2',
                label: 'Fraktavtale',
                pDisabled: false, nDisabled: false,
                pText: 'Tilbake', nText: 'Neste'
            },
            {
                key: 'key3',
                label: 'Godkjenning',
                pDisabled: false, nDisabled: false,
                pText: 'Tilbake', nText: 'Lagre'
            }
        ]
        this.goToStep(startStep);
    },
    onBackgroundLoadingCompleted() {
        this.checkEditorAccess();
    },
    onAdditionalInfoChanged() {
	    $cookies.set('additionalInfo', this.flow.additionalInfo);
    },
    checkEditorAccess() {
        try {
            for (let i in this.$parent.accessList) {
                if (this.$parent.accessList[i].email.toLowerCase().includes(this.customer.editor.email.toLowerCase())) {
                    this.allowSK = true;
                }
            }
        }catch (ex) {
            console.log(ex);
        }
    },
    onCustomerValidated(result) {
        if (result.valid) {
            this.topMessage = 'Sjekk at informasjonen stemmer. Hvis noe må endres, gjør du det i SuperOffice før Fraktavtalen åpnes på nytt.';
            this.topError = false;
            this.updateStep('key1', 'nDisabled', false);
        }else {
            this.topMessage = 'Det mangler informasjon for å gå videre. Oppdater feltene i SuperOffice før du åpner Fraktavtalen på nytt.';
            this.topError = true;
        }
    },
    onShippingValidated(result) {
        this.needsApproval = result.approval;
        if (result.error) {
            this.updateStep('key2', 'nDisabled', true);
        }else {
            this.updateStep('key2', 'nDisabled', false);
        }
    },
    onApproverSelected() {
        for (let i in this.$parent.approvers) {
            if (this.$parent.approvers[i].display == this.selectedApprover.display) {
                this.approver = {
                    name: this.$parent.approvers[i].name,
                    email: this.$parent.approvers[i].email
                };
                this.approverValid = true;
            }
        }
        this.updateStep('key3', 'nDisabled', !this.approverValid);
    },
    async onSubmit() {
        this.submitting = true;
        this.$parent.setLoading(true, this.needsApproval ? 'Sender til godkjenning...' : 'Oppdaterer frakt-tabellen...');

        const pdfStrings = shippingapi.getPDFValues(this.shipping, this.$parent.sheetData.values);

        // Set recipient action
        const flowStep = Number(this.flow.step) + 1;
        let action = 'approve';

        // Prepare recipients
        const recApprover = verified.getRecipient(this.approver);
        const recEditor = verified.getRecipient(this.customer.editor);
        const recAssociate = verified.getRecipient(this.customer.associate);
        let actor = recApprover;

        // Prepare mail
        const mail = {
            step: flowStep,
            action: action,
            subject: 'Ny fraktavtale',
            title: 'Ny fraktavtale',
            message: `Hei ${recEditor.fname}, du har laget en ny fraktavtale.`,
            button: 'Åpne skjema',
            hint: 'Du trenger ikke gjøre noe mer, fraktavtalen kan ses/lastes ned ved å åpne den fra SuperOffice.',
            silentTitle: 'Ny fraktavtale',
            silentMessage: `Hei ${recAssociate.fname}, ${recEditor.fname} har laget en ny fraktavtale for en av dine kunder.`,
        }
        
        // Create or load envelope
        let envelope;
        if (Number(flowStep) > 1) {
            // Get cached envelope from parent-view
            envelope = this.$parent.getEnvelope();
        }else {
            // Authenticate and create envelope
            await verified.authenticatePublic(this.needsApproval);
            envelope = await verified.createEnvelope(this.needsApproval);
        }

        // First, check if this is a rejected envelope, but now don't need approval
        if (!this.needsApproval && Number(flowStep) > 1) {
            // Set actions, no recipient needed
            actor = recEditor;
            action = 'save';
            mail.action = 'save';
            log.v('approval not needed anymore, completing envelope');

            // Update shipping table
            await shippingapi.overwriteShipping(this.customer.number, this.shipping);
            log.s('shipping table updated');
        }else {
            // This is a new envelope
            // Check if we need editor-flow or no-recipient-flow
            if (this.needsApproval) {
                // Set envelope recipient
                await verified.setRecipient(envelope, 'approve', recApprover);
                // Prepare mail
                mail.subject = `Fraktavtale til godkjenning`;
                mail.title = `Fraktavtale til godkjenning`;
                mail.message = `Hei ${recApprover.fname}, ${recEditor.fname} har sendt deg en avtale til godkjenning.`;
                mail.hint = `Klikk på knappen for å gå til skjema og godkjenne/avslå avtalen.`;
            }else {
                // Set silent parties
                const parties = [];
                if (!this.customer.editorIsOwner) {
                    parties.push({
                        givenName: 'Maxbo',
                        familyName: 'Proff',
                        email: recAssociate.email
                    });
                }
                await verified.setSilentParties(envelope, parties);
                // Set envelope recipient
                await verified.setRecipient(envelope, 'sign', recEditor);

                // Update shipping table
                await shippingapi.overwriteShipping(this.customer.number, this.shipping);
                log.s('shipping table updated');
            }
        }

        // Prepare userdata
        const userdata = {
            customer: this.customer,
            socreds: maxbo.socreds,
            shipping: this.shipping,
            flow: {
                step: flowStep,
                action: action,
                actor: actor,
                status: {
                    needsApproval: this.needsApproval,
                },
                approver: recApprover,
                editor: recEditor,
                associate: recAssociate,
	            additionalInfo: this.flow.additionalInfo
            },
            mail: mail,
            pdfStrings: pdfStrings
        };

        // Set data and publish envelope
        if (Number(flowStep) <= 1) await verified.setFilename(envelope, 'Fraktavtale ' + this.customer.name + '.pdf');
        await verified.setUserdata(envelope, userdata);
        if (Number(flowStep) <= 1) await verified.publish(envelope);
        
        this.$parent.setLoading(false);
        this.submitted = true;
        if (!this.needsApproval) {
            this.$parent.updated = true;
            this.$parent.navigate({
                path: '/', 
                /* query: { id: customer._id } */
            }, true);
        }
    }
},
async created() {
	
	Vue.use(VueCookies);
	$cookies.config('365d');
	this.flow.additionalInfo = $cookies.get('additionalInfo') || '';
	
    this.$parent.setLoading(true, 'Henter kunde fra SuperOffice...');

    // Load customer from SuperOffice
    this.customer = await this.$parent.getCustomer();

    this.checkEditorAccess();
    
    // Load shipping from API
    this.$parent.setLoading(true, 'Henter data fra frakt-tabellen...');
    this.shipping = await this.$parent.getShipping();

    // Prepare shipping object
    shippingapi.setMaxDiscounts(this.shipping, this.$parent.sheetData.values);
    shippingapi.setDropdownDiscounts(this.shipping, this.$parent.sheetData.values);
    shippingapi.setOriginalPrices(this.shipping, this.$parent.sheetData.values);

    this.thresholdValues = shippingapi.getThresholdValues(this.$parent.sheetData.thresholds);

    if (this.$parent.isEditor) {
        this.flow = this.$parent.getFlow();
        if (this.flow.status.wasApproved) {
            this.initSteps('key3');
        }else {
            this.initSteps('key2');
        }
    }else {
        this.initSteps('key1');
    }
    
    this.loading = false;
    this.$parent.setLoading(false);
}
}
</script>
<style scoped>

.top-message-margin {
    margin-top: 102px;
}

.af-textarea .vm-label {
	text-align: right;
	color: #959595;
}

.af-textarea textarea {
	width: calc(100% - 6px);
	border: 1px solid #d3d3d3;
	border-bottom: 2px solid rgb(0, 73, 118);
	resize: vertical;
	min-height: 36px;
	font-size: 15px;
	font-family: inherit;
	outline: none;
	padding: 8px;
}

</style>